import { Skeleton } from '../Skeleton';
import { SummaryCard } from './SummaryCard';

/** @deprecated Use `components/ui/SummaryCard` instead. */
export const SummaryCardSkeleton = () => (
  <SummaryCard>
    <SummaryCard.Content>
      <SummaryCard.Col variant="title">
        <SummaryCard.Eyebrow>
          <Skeleton width={200} />
        </SummaryCard.Eyebrow>
        <SummaryCard.Title>
          <Skeleton width={200} />
        </SummaryCard.Title>
        <Skeleton height={20} width={88} />
      </SummaryCard.Col>
      <SummaryCard.Col>
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
      </SummaryCard.Col>
      <SummaryCard.Col>
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
      </SummaryCard.Col>
      <SummaryCard.Col>
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
        <Skeleton height={19} width={154} />
      </SummaryCard.Col>
    </SummaryCard.Content>
  </SummaryCard>
);
